import * as mutations from "@app/graphql/mutations/cart"
import * as queries from "@app/graphql/queries/cart"

export const useQueries = () => {
  return {
    graphql: { mutations, queries },
  }
}
